module.exports = __webpack_public_path__ + "static/grung_purple_bangrang-e46b18f0bbaddc499ecd9ff346be19d9.jpg";